import firebase from 'firebase'

const config ={
    apiKey: "AIzaSyBm4hm4chzYtCor2JyjCFs2lY3d7UFiFMI",
    authDomain: "health-book-d1a20.firebaseapp.com",
    databaseURL: "https://health-book-d1a20.firebaseio.com",
    projectId: "health-book-d1a20",
    storageBucket: "health-book-d1a20.appspot.com",
    messagingSenderId: "423708904913",
    appId: "1:423708904913:web:fd35c0ab8d3507f28464f0",
    measurementId: "G-C87R76JP77"

}
firebase.initializeApp(config)

export default firebase